var React = require("react");

exports.useEffectAlways_ = (effect) => () => React.useEffect(effect);
exports.useLayoutEffectAlways_ = (effect) => () =>
  React.useLayoutEffect(effect);
